import { render, staticRenderFns } from "./baseimport.vue?vue&type=template&id=440cc561&scoped=true&"
import script from "./baseimport.vue?vue&type=script&lang=js&"
export * from "./baseimport.vue?vue&type=script&lang=js&"
import style0 from "./baseimport.vue?vue&type=style&index=0&id=440cc561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440cc561",
  null
  
)

export default component.exports